var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};pug_html = pug_html + "\u003Cdiv class=\"Footer\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"madeby\"\u003E\u003Ca href=\"https:\u002F\u002Fwww.drawbotics.com\u002F\" target=\"_blank\"\u003EMade by Drawbotics\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/footer.pug
// module id = 18
// module chunks = 0